import { createAction, props } from '@ngrx/store';
import { DynamicPermissionEntity } from '@resident-select/domain/dynamic-permission';

export const GottenDynamicPermissionsDomainEvent = createAction(
  'GottenDynamicPermissionsDomainEvent',
  props<{ dynamicPermissions: DynamicPermissionEntity[] }>(),
);

export const GottenDynamicPermissionsByQueryDomainEvent = createAction(
  'GottenDynamicPermissionsByQueryDomainEvent',
  props<{
    dynamicPermissions: DynamicPermissionEntity[];
  }>(),
);
export const CreatedDynamicPermissionDomainEvent = createAction(
  'CreatedDynamicPermissionDomainEvent',
  props<{
    dynamicPermission: DynamicPermissionEntity;
  }>(),
);
export const UpdatedDynamicPermissionDomainEvent = createAction(
  'UpdatedDynamicPermissionDomainEvent',
  props<{
    dynamicPermission: DynamicPermissionEntity;
  }>(),
);
